import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import { getSliders } from '../Service/Api'

const defaultImage = 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJHSMD/public/Images/sld-1.jpg'
const imageBaseUrl = 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/'

const HomeSlider = () => {
  const [sliders, setSliders] = useState([])

  useEffect(() => {
    getSliders()
      .then(data => {
        const visibleSliders = Array.isArray(data)
          ? data
              .filter(slider => slider.visibility === false && slider.attachment?.length > 0)
              .sort((a, b) => a.position - b.position)
          : []

        setSliders(visibleSliders)
      })
      .catch(() => setSliders([]))
  }, [])

  const carouselSliders = sliders.length
    ? sliders
    : [{ attachment: 'SJHSMD/public/Images/sld-1.jpg', title: 'St. Joseph High School' }]

  return (
    <>
      <div className="slider-sec">
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {carouselSliders.map((slider, index) => (
              <div
                className={`carousel-item${index === 0 ? ' active' : ''}`}
                data-bs-interval="3000"
                key={slider._id || slider.attachment}
              >
                <img
                  src={`${imageBaseUrl}${slider.attachment}`}
                  className="d-block w-100"
                  alt={slider.title || 'St. Joseph High School'}
                  onError={event => {
                    event.currentTarget.src = defaultImage
                  }}
                />
              </div>
            ))}
          </div>

          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <div className="kidslogo">
          <Link to="/KidsCorner">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJHSMD/public/Images/kids.png"
                className="img-fluid"
                alt=" St. Joseph High School"
              />
            </LazyLoad>
          </Link>
        </div>
      </div>
    </>
  )
}

export default HomeSlider
